var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "modal-X-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 17 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56104 0.663352C8.90581 0.663352 8.37465 1.19451 8.37465 1.84974L8.37465 16.6144C8.37465 17.2696 8.90581 17.8008 9.56104 17.8008C10.2163 17.8008 10.7474 17.2696 10.7474 16.6144L10.7474 1.84974C10.7474 1.19451 10.2163 0.663352 9.56104 0.663352Z",
    fill: "#FF6633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 17.1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.992393 9.23206C0.992393 8.57683 1.52355 8.04567 2.17878 8.04567L16.9434 8.04567C17.5986 8.04567 18.1298 8.57683 18.1298 9.23205C18.1298 9.88728 17.5986 10.4184 16.9434 10.4184L2.17878 10.4184C1.52355 10.4184 0.992393 9.88728 0.992393 9.23206Z",
    fill: "#FF6633"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSign);
export default __webpack_public_path__ + "static/media/plus-sign.0bcc549b5c66830f25a2b2808118e058.svg";
export { ForwardRef as ReactComponent };